import React from 'react';

import Footer from 'components/Shared/Footer';
import Header from 'components/Shared/Header';
import Content from './Content';
import { PrintProvider } from './Content/Ticket/context';

import * as S from './styles';

const Participant = () => {
  return (
    <PrintProvider>
      <S.Wrapper>
        <S.HeaderContainer>
          <Header />
        </S.HeaderContainer>

        <S.ContentContainer>
          <Content />
        </S.ContentContainer>

        <S.FooterContainer>
          <Footer />
        </S.FooterContainer>
      </S.Wrapper>
    </PrintProvider>
  );
};

export default Participant;
